@if (isOpen) {
    <div>
        <form
            [formGroup]="form"
            (submit)="submit()"
        >
            <div class="grid-container">
                <div class="g-12 m-12:b md:m-16:b lg:m-24:b">
                    <p>Bitte wähle Laufzeit und Beginn deines Versicherungsschutzes:</p>
                </div>
                <div class="g-12 form-control">
                    <label
                        for="contract-duration"
                        formControlName="contractPeriod"
                        appReactiveLabel
                    >
                        Gewünschte Laufzeit*:
                    </label>
                    <div class="contract-duration-picker">
                        <select
                            id="contract-duration"
                            formControlName="contractPeriod"
                            [ctrlErrorMessage]="contractPeriodErrorMessages"
                            required
                        >
                            <option
                                disabled="disabled"
                                [value]="null"
                            >
                                {{ 'Gewünschte Laufzeit' | formLabel: true : 'select' }}
                            </option>
                            @for (cpOption of contractPeriodOptions; track cpOption) {
                                <option [ngValue]="cpOption.value">
                                    {{ cpOption.label }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div class="grid-container">
                <div class="contract-duration-picker g-12 form-control">
                    <label
                        id="contract-start-label"
                        formControlName="contractStart"
                        appReactiveLabel
                        [reactive]="false"
                    >
                        Vertragsbeginn*:
                    </label>
                    <app-contract-start-picker
                        formControlName="contractStart"
                        [monthsInAdvance]="product()?.orderConfig.monthsInAdvance"
                        [mode]="product()?.orderConfig.contractStartMode"
                        [ctrlErrorMessage]="contractStartErrorMessages"
                        labelledById="contract-start-label"
                    ></app-contract-start-picker>
                </div>
            </div>
            <app-navigation-buttons
                [nextDisabled]="form.invalid"
                [showBack]="isFirstStep"
                (prev)="btnPrev()"
                (next)="submit()"
                nextTooltip="Bitte wähle die Vertragslaufzeit über das Auswahlfeld."
            ></app-navigation-buttons>
        </form>
    </div>
}
